module.exports = __webpack_public_path__ + "static/11-8aacdeae71a1c8cad81506cfc452b3c6.gif";